module.exports = __webpack_public_path__ + "img/picto-nbre-terrain.bc20054d.svg";